/* Ashcroft 18-9-2026: ApxSlider (apex-vendor.js) erft van Emitter maar roept de Emitter-constructor niet aan,
   zodat this._handlers ontbreekt en option() crasht op this.on('ready', ...). Daardoor startte de productslider
   niet en bewoog het beeld niet mee bij een kleurwissel. Deze patch zet _handlers klaar voor option() draait. */
(function () {
  var S = window.ApxSlider;
  if (!S || !S.prototype || S.prototype.__ashcroftHandlersFix) return;
  var option = S.prototype.option;
  S.prototype.option = function (opts) {
    if (!this._handlers) this._handlers = {};
    return option.call(this, opts);
  };
  S.prototype.__ashcroftHandlersFix = true;
})();
